<template>
  <div class="pay_H">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="pay_main_body">
        <Pay_jtzz></Pay_jtzz>

        <Footer></Footer>
      </el-main>
    </el-container>

    <Xuanfuret></Xuanfuret>
  </div>
</template>

<script>
import api from "@/requset/api";
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import Pay_jtzz from "@/components/pay_/pay_jtzz.vue";
import Pay_dxsjzx from "@/components/pay_/pay_dxsjzx.vue";

export default {
  name: "pay",
  components: {Head, Footer, Xuanfuret, Pay_jtzz, Pay_dxsjzx},
  data() {
    return {
      checked: "",
      form: {
        phone: "",
        pass: "",
      },
      formyzm: {
        mobile: "",
        captcha: "",
        checkMove: "",
      },
      selectedPaymentMethod: "alipay", // 默认选择的支付方式
      packageType: "基础套餐", // 套餐类型
      rechargeAmount: 100, // 额度充值
      packageid: 0,
      unitPrice: 10, // 单价时效
      actualPayment: 100, // 实际支付金额
      mima_show: true,
      yanzma_show: false,
      dialogFormVisiblelogin: false,
      dialogFormVisibledindan: false,
      IPsum: "",
      img_show: true,
      selectedLabels: [],
      selectedLabelsdata: [],
      selectedPackage: null,
      input3: "",
      dongtaibaoyue: true,
      jingtaizhuzhai: false,
      duxiangsjzx: false,
      activeNames: "",
      isClickedA: false,
      isClickedB: false,
      isClickedC: false, // 用于跟踪按钮是否被点击
      edcz_div_show: true,
      cptc_div_show: false,
    };
  },
  computed: {
    buttonStyleB() {
      return {
        backgroundColor: this.isClickedB ? "#3a2464" : "#fff", // 背景颜色
        color: this.isClickedB ? "white" : "black", // 字体颜色
      };
    },
  },
  mounted() {
  },
  created() {
    // 在组件创建时获取路由参数
    // this.userId = this.$route.params.id;
    let types = this.$route.query.lable;
    let order_sn = this.$route.query.out_trade_no;

    this.edcz_div_show = false;
    this.cptc_div_show = true;
    this.changeStyleB();
    if (order_sn) this.check_order(order_sn);
  },
  beforeDestroy() {
  },
  methods: {
    check_order(order_sn) {
      const token = this.$cookies.get("userdata");
      api.check_order(
          {
            order_sn: order_sn
          },
          token.data.token
      )
          .then((res) => {
            if (res.data.error_code != 0) {
              this.$message({
                message: "未检测到支付成功订单，请稍后再试",
                type: "warning",
              });
              return
            }
            this.$message({
              message: "支付成功",
              type: "success",
            });
            this.$router.push({path: "ucenter", query: {asidename: 'order_list'}});
          })
          .catch(() => {
            this.$message({
              message: "未检测到支付成功订单，请稍后再试",
              type: "warning",
            });
          });
    },
    pay() {
      // 支付逻辑
      console.log(`选择的支付方式: ${this.selectedPaymentMethod}`);
      console.log(`实际支付金额: ${this.actualPayment}`);
      // 这里可以添加支付请求的逻辑
      this.dialogFormVisibledindan = false; // 关闭对话框
    },
    loginshow(inlist) {
      console.log(inlist);
      this.packageType = inlist.type;
      this.rechargeAmount = inlist.jiage;
      this.unitPrice = 30;
      this.actualPayment = inlist.jiage;
      this.packageid = inlist.id;
      // packageType: "基础套餐", // 套餐类型
      // rechargeAmount: 100, // 额度充值
      // unitPrice: 10, // 单价时效
      // actualPayment: 100, // 实际支付金额beizhu
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.dialogFormVisiblelogin = true;
      } else {
        this.dialogFormVisibledindan = true;
      }
    },
    touserlogin() {
      this.$router.push({path: "userlogin"});
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
    },
    codeLogin() {
      if (this.checked) {
        api
            .loginIn({
              mobile: this.form.phone,
              password: this.form.pass,
            })
            .then((res) => {
              console.log(res.data);
              if (res.data.error_code == 0) {
                this.$cookies.set("userdata", res.data);
                this.$router.push({
                  path: "getapi",
                  query: {name: "api提取"},
                });
              } else {
                this.$message({
                  message: res.data.message,
                });
              }
            })
            .catch((err) => {
              console.log(err, "走失败");
            });
      } else {
        this.$message({
          message: "请勾选《全球HTTP用户协议》",
          type: "warning",
        });
      }
    },

    openzhifu() {
      const token = this.$cookies.get("userdata");
      console.log(token);
      api
          .order_create(
              {
                amount: JSON.stringify(this.rechargeAmount),
                zfamount: JSON.stringify(this.rechargeAmount),
                pay: 1,
                seal_type: this.packageid,
              },
              token.data.token
          )
          .then((res) => {
            console.log(res.data.data);
            window.open(res.data.data);
          })
          .catch((err) => {
          });
    },

    openWeChatChat() {
    },
    handleChange() {
    },
    changeStyleB() {
      this.jingtaizhuzhai = true;
      this.dongtaibaoyue = false;
      this.duxiangsjzx = false;
      this.isClickedB = !this.isClickedB; // 切换点击状态
      this.isClickedA = false;
      this.isClickedC = false;
    },
  },
};
</script>

<style scoped>
.pay_group {
  margin: 20px 0 20px 0;
}

.selected-radio {
  /* box-shadow: rgba(60, 59, 145, 0.2) 0px 2px 8px 0px; */
  box-shadow: rgba(49, 176, 214) 0px 1px 4px, rgb(49, 176, 214) 0px 0px 0px 3px;
  border-radius: 4px;
  /* 设置边框圆角 */
  padding: 10px;
  /* 内边距 */
}

.radio-content {
  display: flex;
  /* 使用 Flexbox 布局 */
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: flex-start;
  /* 水平左对齐 */
  margin-top: 20px;
}

.payment-icon {
  display: inline-block;
  width: 20px;
  /* 图标宽度 */
  height: 20px;
  /* 图标高度 */
  margin-right: 8px;
  /* 图标与文本之间的间距 */
  background-size: cover;
  /* 背景图像覆盖 */
}

.wechat-icon {
  background-image: url("../../assets/wx.svg");
  /* 微信图标路径 */
}

.alipay-icon {
  background-image: url("../../assets/zfb3.svg");
  /* 支付宝图标路径 */
}

.pay_dindan_ {
  display: flex;
  justify-content: space-between;
}

.pay_dindan_left,
.pay_dindan_reft {
  width: 48%;
  /* 控制左右两部分的宽度 */
  padding: 20px;
}

.pay_dindan_left {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: left;
}

.payment-notice {
  margin-top: 20px;
  font-size: 12px;
  color: #999;
}

.payment-notice > p {
  display: flex;
  justify-content: space-around;
}

.order-details {
  margin: 0px auto;
  width: 300px;
  padding: 20px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
  rgba(29, 131, 172, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  border-radius: 20px;
}

.order-details > p {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.order-details > p > strong {
  /* text-align: left; */
  margin-right: 50px;
  text-align: left;
}

.home_H {
  position: relative;
}

.el-icon-circle-close {
  font-size: 30px;
  color: #edf3fc;
}

.el-icon-arrow-down,
.el-icon-user {
  font-weight: 600;
}

.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-header {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}

.imgstop_text {
  display: flex;
  justify-self: center;
  font-size: 25px;
  font-weight: 550;
  background-color: #edf3fc;
  width: 500px;
  margin: 0 auto;
}

.imgstop {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/tops.png");
  background-size: cover;
}

.imgstop > div div {
  color: #f15a24;
}

.imgstop_text {
  display: flex;
  justify-self: center;
  font-size: 25px;
  font-weight: 550;
  background-color: #edf3fc;
  width: 500px;
  margin: 0 auto;
}

.pay_main_body_divA_div_H {
  font-size: 38px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  text-align: center;
  color: #1b2336;
  margin-top: 50px;
}

.pay_main_body_divA_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: rgba(27, 35, 54, 0.68);
  position: relative;
  width: max-content;
  margin: 16px auto 0;
}

.pay_main_body_divA_div_text_butts_divA {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 113px;
  height: 32px;
  z-index: 11;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 16px;
  color: #1b2336;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  line-height: 32px;
}

.pay_main_body_divA_div_text_butts_divB {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 113px;
  height: 32px;
  z-index: 11;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 16px;
  color: #1b2336;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  line-height: 32px;
}

.pay_main_body_divA_div_text_butts {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pay_img_textA {
  display: flex;
  justify-content: space-between;
  width: 700px;
}

.pay_img_textA > div {
  letter-spacing: 1px;
  margin-left: 7px;
  font-size: 14px;
  color: #100043;
}

.pay_img_textA_img {
  margin-top: 5px;
}

.pay__div_img_textA {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}

.div_jiajian_butt {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.div_jiajian_buttB {
  display: flex;
  justify-content: left;
  margin-top: 8px;
  margin-bottom: 8px;
}

.div_jiajian_butt_text {
  border: none;
  background: transparent;
  font-size: 40px;
  line-height: 52px;
  height: 52px;
  font-weight: 600;
  color: #240009;
  padding-left: 20px;
  padding-right: 20px;
}

.div_jiajian_butt_textB {
  border: none;
  background: transparent;
  font-size: 40px;
  line-height: 52px;
  height: 52px;
  font-weight: 600;
  color: #240009;
  /* padding-left: 20px; */
  padding-right: 20px;
  text-align: left;
}

.div_jiajian_butt_A {
  width: 40px;
  height: 40px;
  margin: 5px 0 0 0;
}

.div_jiajian_butt_B {
  width: 40px;
  height: 40px;
  margin: 5px 0 0 0;
}

.pay_main_body_divB {
  margin-top: 100px;
}

.pay_main_body_divB_div_div_div {
  width: 262px;
  /* height: 480px; */
  padding-top: 80px;
  padding-right: 20px;
  padding-left: 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.pay_main_body_divB_div_div_div:hover {
  box-shadow: rgba(99, 99, 99, 0.9) 0px 2px 8px 0px;
}

.pay_main_body_divB_div_div_div:hover .pay_main_body_divB_div_div_div_div {
  transform: translateY(-50px);
}

.pay_main_body_divB_div_div_div:hover .div_jiajian_butt_text {
  color: #6327d3;
}

.pay_main_body_divB_div_div_div_yhgm {
  transition: 0.4s;
  height: 52px;
  background: linear-gradient(90deg, #6327d3, #261644);
  box-shadow: 0 -2px 15px 0 #f3f3f3;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #f1f2f4;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 16px;
  color: #edf3fc;
  margin: 19px auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.pay_main_body_divB_div_div_div_div_span {
  display: flex;
  justify-content: right;
}

.pay_main_body_divB_div_div_div_div_span > span {
  background-color: #6327d3;
  color: #edf3fc;
  /* padding: 5px; */
  line-height: 20px;
  border-radius: 15px;
  font-size: 15px;
  padding-right: 10px;
  padding-left: 10px;
}

.pay_main_body_divB_div_div_div_div_text {
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #171a1f;
}

.pay_main_body_divB_div_div_div_div_textB {
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #171a1f;
  text-align: left;
}

.jcdj {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
}

.pay_main_body_divB_div_div {
  position: relative;
  /* min-height: 580px; */
  max-width: 1310px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  z-index: 0;
}

.pay_main_body_divB_div_divB {
  position: relative;
  /* min-height: 580px; */
  max-width: 1510px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  z-index: 0;
}

.dov_top {
  transition: 0.4s;
  padding-top: 20px;
}

.pay_main_body_divB_div_div_div:hover .dov_top {
  transform: translateY(-10px);
}

.pay_main_body_divB_div_div_div:hover .pay_main_body_divB_div_div_div_yhgm {
  background: linear-gradient(90deg, #ffffff, #ffffff);
  color: #6327d3;
  border: 1px solid #6327d3;
}

.pay_main_body_divC_div {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  position: relative;
  /* min-height: 580px; */
  max-width: 1480px;
  margin: 0 auto;
  z-index: 0;
  padding-right: 200px;
}

.pay_main_body_divC_div_ {
  width: 226px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
  cursor: pointer;
  position: relative;
}

.pay_main_body_divC_div_div:nth-child(odd) {
  color: #6327d3;
}

.pay_main_body_divC_div_ > div:nth-child(1) {
  width: 80%;
  font-size: 14px;
}

.pay_main_body_divC_div_ > div:nth-child(2) {
  width: 20%;
  font-size: 14px;
  text-align: right;
  white-space: nowrap;
  text-decoration: line-through;
  /* 添加删除线 */
}

.pay_main_body_divC_div_div {
  display: flex;
  justify-content: space-between;
}

.pay_main_body_divC_div_div:hover .div_li_showB {
  opacity: 1;
  width: 150px;
  transition: 0.4s;
}

.pay_main_body_divC_div_div:hover {
  color: #6327d3;
}

.pay_main_body_divC_div_div:hover .pay_main_body_divC_div_div_let {
  color: #6327d3;
}

.pay_main_body_divC_div_div:hover .el-icon-caret-right {
  color: #6327d3;
  opacity: 1;
}

.el-icon-caret-right {
  display: flex;
}

.pay_main_body_divC_div_div_let {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  width: 150px;
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #170f49;
  display: flex;
  align-items: center;
}

.el-icon-caret-right {
  opacity: 0;
}

.div_li_showB {
  display: flex;
  justify-content: center;
  opacity: 0;
  font-size: 12px;
  width: 0px;
  border: 1px solid #6327d3;
  border-radius: 15px;
  position: absolute;
  left: 140px;
  background-color: #edf3fc;
  color: #6327d3;
}

.pay_main_body_divD_div {
  display: flex;
  justify-content: center;
}

.pay_main_body_divD_div_div {
  width: 1328px;
  height: 185px;
  display: flex;
  justify-content: space-around;
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
  padding: 30px;
  border-radius: 25px;
  margin-top: 100px;
}

.pay_main_body_divD_div_div_div_img {
  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.but_div_ljdz > div {
  margin: 0 auto;
}

.but_div_ljdz {
  width: 174px;
  height: 50px;
  display: flex;
  align-items: center;
  color: #edf3fc;
  background: linear-gradient(90deg, #6327d3, #120b1f);
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 17px;
  box-shadow: 0 4px 5.3px 0 rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  margin-top: 70px;
}

.dingzhi1V1 {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-right: 40px;
}

.dztc_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 31px;
  color: #14171a;
  margin-left: 37px;
  margin-top: 40px;
}

.dingzhi1V1 > div {
  margin-right: 20px;
}

.dingzhi1V1_text {
  text-align: left;
  margin: 20px;
  font-size: 14px;
}

.pay_main_body_divE {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}

.pay_main_body_divE > div {
  width: 1400px;
}

.collapse_text {
  text-align: left;
  color: #3194ce;
}

.but_Htext {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 38px;
  color: #1b2336;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px;
}

.top_button_djd {
  width: max-content;
  height: 42px;
  border: 1px solid rgba(145, 50, 47, 0.18);
  border-radius: 30px;
  display: flex;
  align-items: center;
  padding: 0 7px;
  margin: 28px auto 0;
}

.top_button_djd_A {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 16px;
  color: #1b2336;
  cursor: pointer;
  border-radius: 30px;
  height: 32px;
  width: max-content;
  line-height: 32px;
  padding: 0 20px;
  margin-right: 10px;
}

.jcdjB {
  color: #100043;
  font-size: 14px;
  text-align: left;
  margin-top: 4px;
  font-weight: 400;
  font-family: SourceHanSansCN-Regular;
}

.jcdjC {
  color: #6327d3;
  font-size: 14px;
  text-align: left;
  margin-top: 4px;
  font-weight: 400;
  font-family: SourceHanSansCN-Regular;
}

.div_jiajian_butt_text_B {
  height: 16px;
  background: #edf3fc;
  border-radius: 2px;
  border: 1px solid #6327d3;
  display: inline-block;
  padding: 0 5px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #6327d3;
  width: max-content;
  line-height: 16px;
  transform: translateY(-4px);
  margin-left: 10px;
}

.div_jiajian_butt_text_C {
  transition: 0.4s;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  width: 300px;
  text-transform: uppercase;
  margin-bottom: 31px;
}

.edcz_butt {
  width: 120px;
  background-color: #5b5ab4;
  color: #edf3fc;
  border: none;
}

.edcz_butt:hover {
  background-color: #262664;
}

.cptc_butt {
  width: 120px;
  background-color: #5b5ab4;
  color: #edf3fc;
  border: none;
}

.cptc_butt:hover {
  background-color: #262664;
}

.pay_main_body_divC_main {
  margin-bottom: 500px;
}

.div_4 > div {
  margin-top: 50px;
  width: 1400px;
}

.H_qq {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 30px;
  color: #292626;
  width: 100px;
  background: #edf3fc;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 30px;
  white-space: nowrap;
}

.a_text {
  position: relative;
  display: inline-block;
  padding: 8px;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  max-width: 214px;
  height: 56px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #f8fbff;
  border: 1px solid #a0c1f7;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
}

.retop_img {
  position: absolute;
  top: -8px;
  right: -11px;
  transform: rotate(-10deg);
}

.a_texttype {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 20px;
  color: #13497f;
}

.duoxuan {
}

.pay_main_body_divC_main_div_divB_divB_div_div_top {
}

.pay_main_body_divC_main_div_divB_divB_div_div_top > div:nth-child(1) {
  margin-top: 6px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #18195a;
}

.pay_main_body_divC_main_div_divB_divB_div_div_top > div:nth-child(2) {
  font-size: 14px;
  color: #e08841;
  font-family: SourceHanSansCN-Medium;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}

.pay_div_div_inputs {
  height: 400px;
  overflow: hidden;
  overflow-y: auto;
  margin-bottom: 20px;
}

.div_inputs {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.div_inputs > div {
  font-size: 18px;
  margin-right: 10px;
  color: #100043;
  width: 80px;
  font-size: 14px;
  text-align: left;
}

.div_inputs > div:nth-child(1) {
  height: 10px;
}

.div_inputs > div:nth-child(3) > .el-input-number {
  width: 100px;
  /* margin-top: -5px; */
}

.pay_div_div_nums {
  width: 270px;
  margin: 0 auto;
}

.pay_div_div_nums > div {
  margin-top: 10px;
}

.pay_div_div_nums > div:nth-child(1) {
  text-align: right;
  font-weight: 400;
  font-size: 12px;
  color: #000;
  align-items: center;
  cursor: pointer;
}

.pay_div_div_nums > div:nth-child(2) {
  display: flex;
  justify-content: space-between;
}

.pay_div_div_nums > div:nth-child(3) {
  display: flex;
  justify-content: space-between;
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 16px;
  color: #1b2336;
}

.pay_div_div_nums > div:nth-child(4) {
  width: 100%;
  padding: 10px 0 10px 0;
  line-height: 0.889rem;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  border-radius: 100px;
  background: linear-gradient(152deg, #ffb85a 11%, #ff5e38);
  font-family: SourceHanSansCN-Medium;
  color: #edf3fc;
}

.pay_div_div_nums > div:nth-child(5) {
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
  color: rgba(27, 35, 54, 0.68);
}

.jia_jian_div {
  display: flex;
  justify-content: space-around;
  padding: 2px 0px 2px 0px;
  border: 1px solid #bdbdbd;
  border-radius: 20px;
}

.div_inputs_jian {
  padding: 0 5px 0 5px;
}

.div_inputs_input {
  padding: 0 10px 0 10px;
}

.div_inputs_jia {
  padding: 0 5px 0 5px;
}
</style>
